import React from 'react';
import { motion } from 'framer-motion';
import './Header.css';
//import CV from '../../assets/Wafa_Ben_Miloud.pdf'
import lamp from '../../assets/lamp.png'
import light from '../../assets/light.png'
import { BsLinkedin, BsGithub } from 'react-icons/bs'
import { SiUpwork } from 'react-icons/si'
import DarkMode from '../DarkMode/DarkMode'
import { SiGumroad } from "react-icons/si";
import { staggerContainer, staggerItem } from '../motion/variants';
import HeroPitch from './HeroPitch';
import { FaCode, FaReact, FaDatabase, FaTerminal, FaCodeBranch } from 'react-icons/fa';
import { MdAutoAwesome } from 'react-icons/md';

// Small coding bubbles that drift around the hero. Purely decorative: each one gets its own
// position, size and float timing from Header.css (.hero-floater--1 … --7).
const FLOATERS = [
  <FaCode />,
  <span className="hero-floater__text">{'{ }'}</span>,
  <FaReact />,
  <FaTerminal />,
  <FaDatabase />,
  <FaCodeBranch />,
  <MdAutoAwesome />,
];

const Header = () => {
  return (
    <header>

      <DarkMode />
      <div className="hero-floaters" aria-hidden="true">
        {FLOATERS.map((icon, i) => (
          <span key={i} className={`hero-floater hero-floater--${i + 1}`}>{icon}</span>
        ))}
      </div>
      <div className="lamp_wrapper">

        <img src={lamp} alt="lamp" className="lamp" />
        <img src={light} alt="light" className="light" />

      </div>
      <motion.div
        className='container header__container'
        initial="hidden"
        animate="visible"
        variants={staggerContainer}
      >
        <motion.div className="header__badge" variants={staggerItem}>Available for Hire</motion.div>
        <motion.h1 variants={staggerItem}>Wafa Ben Miloud</motion.h1>
        <motion.h5 className='text-light' variants={staggerItem}>AI Software Engineer</motion.h5>
        <motion.div className='cta' variants={staggerItem}>
        {/* <a href={CV} download className='btn'>Download CV</a>*/}  
          <a href="#contact" className='btn'>How Can I Help ? </a>
        </motion.div>
        <motion.div className='row' variants={staggerItem}>


        <div className='header__socials'>
            <a href="https://www.linkedin.com/in/wafa-ben-miloud-382126181/" target="_blank" rel="noreferrer"><BsLinkedin/></a>
            <a href="https://github.com/wafabenmiloud" target="_blank" rel="noreferrer"><BsGithub/></a>
            <a href="https://www.upwork.com/freelancers/~01fc5f7163d2b11b28?viewMode=1" target="_blank" rel="noreferrer"><SiUpwork/></a>
            <a href="https://wafabenmiloud.gumroad.com/" target="_blank" rel="noreferrer"><SiGumroad/></a>
          </div>
          <div className="block">
            <div className="blob">
              <div className='me'>
              </div>
            </div>

            <HeroPitch />
          </div>
          <a href="#contact" className='scroll__down'>Scroll</a>

        </motion.div>

      </motion.div>
    </header>
  )
}

export default Header
